'use client';
import { Button } from '@scaleup/frontend/ui';
import { IconCheck } from '@tabler/icons-react';
import { useTermsWizardContext } from './context';

export const Success = () => {
  const { setShow } = useTermsWizardContext();

  return (
    <div className="rounded-[2rem] bg-primary-100 flex justify-center p-16">
      <div className="flex flex-col gap-6 p-8 max-w-[40rem] w-full items-center text-center">
        <div className="rounded-full flex items-center justify-center bg-green-500 w-[4rem] h-[4rem]">
          <IconCheck size={48} stroke={3} color="#ffffff" />
        </div>

        <p className="text-text-primary text-3xl font-bold">
          Terms Accepted!
        </p>

        <p className="text-text-primary text-lg">
          Thank you for accepting our Terms and Conditions. You can now continue using the Scaleup platform.
        </p>

        <div className="w-[140px] pt-4">
          <Button
            variant="secondary"
            onClick={() => setShow(false)}
            text="Continue"
          />
        </div>
      </div>
    </div>
  );
};
